export enum QuestionTypeEnum {
    MULTIPLECHOICE = 'MULTIPLECHOICE',
    ESSAY = 'ESSAY'
}